import { createTheme } from "@mui/material/styles";

/**
 * Basic theme for loading screens before Redux is ready
 * This is a static theme - no dark mode or RTL support
 */
const basicTheme = createTheme({
  palette: {
    primary: {
      main: "#1d8354"
    },
    secondary: {
      main: "#3e7ddbfa"
    },
  },
  typography: {
    fontFamily: "Roboto, Arial, sans-serif"
  }
});

export default basicTheme;